import axios from "src/utils/axios";
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getMaintenanceStatus = async ({ signal }) => {
  const { data } = await axios.get('/auth/maintenance', { signal });
  return data;
};
export const ordersSchool = async ({ queryKey, signal }) => {
  const [_, schoolID, years, branchID, packageID, status, startDate, endDate, vendorID, shippingType, addmissionType] =
    queryKey;

  const queryParams = new URLSearchParams();

  if (branchID) queryParams.append("branchID", branchID);
  if (packageID) queryParams.append("packageID", packageID);
  if (status) queryParams.append("status", status);
  if (startDate) queryParams.append("fromDate", startDate);
  if (endDate) queryParams.append("toDate", endDate);
  if (vendorID) queryParams.append("vendorId", vendorID); 
  if (shippingType) queryParams.append("shippingType", shippingType);
  if (addmissionType) queryParams.append("addmissionType", addmissionType);


  years.forEach((year) => queryParams.append("years", year)); // Always append years

  const url = `orders/school/groupschool/${schoolID}?${queryParams.toString()}`;

  const { data } = await axios.get(url, { signal });
  return data.data;
};
export const ordersList = async ({ queryKey, signal }) => {
  const selectedBranchID = queryKey[8]; 
  let branchIDs = [];

  if (!selectedBranchID) {
    // If no specific school is selected, fetch all branch IDs
    const { data } = await axios.get(`/orders/school/groupschoollist/${queryKey[1]}`);
    branchIDs = Array.isArray(data?.data) ? data.data.map((school) => school.branchID) : [];
  } else {
    // If a school is selected, only use that branch ID
    branchIDs = [selectedBranchID];
  }

  const req = {
    packageID: queryKey[2] ? +queryKey[2] : undefined,
    status: queryKey[3] || undefined,
    fromDate: queryKey[4] || undefined,
    toDate: queryKey[5] || undefined,
    year: queryKey[6]?.length ? queryKey[6].join(",") : new Date().getFullYear().toString(),
    shippingType: queryKey[7] ? +queryKey[7] : undefined,
    schoolID: queryKey[8] ? +queryKey[8] : undefined,
    vendorId: queryKey[9] ? +queryKey[9] : undefined,
    addmissionType: queryKey[10] ? +queryKey[10] : undefined,
    branchID: branchIDs.length ? branchIDs.join(",") : undefined, // Ensuring correct filtering
  };

  const { data } = await axios.post("orders/school/list", req, { signal });
  return data.data;
};
export const ordersSingleOrder = async ({ queryKey, signal }) => {
  const { data } = await axios("orders/singleOrder/" + queryKey[1]);
  return data.data;
};
export const masterGetData = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/getData",
    { tableName: queryKey[1], page: +queryKey[2] + 1, limit: queryKey[3] },
    { signal }
  );
  return data?.data[0] || [];
};
export const getProducts = async ({ queryKey, signal }) => {
  const [_, pageIndex,pageSize,categoryId] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      ...(categoryId && { categoryId }),
    },
    signal,
  };

  try {
    const response = await axios.get(`master/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const saveStudentKit = async ({ signal, req }) => {
  const { data } = await axios.post("master/school/addSizes", req, { signal });
  return data;
};
export const getOrderSummary = async ({ schoolID, vendorId, fromDate, toDate, years }) => {
  const params = new URLSearchParams();
  
  if (schoolID) params.append("schoolID", schoolID);
  if (vendorId) params.append("vendorId", vendorId);
  if (fromDate) params.append("fromDate", formatDate(fromDate));
  if (toDate) params.append("toDate", formatDate(toDate));
  years.forEach((year) => params.append("years", year)); 


  const url = `orders/school/ordersummary?${params.toString()}`;
  const { data } = await axios.get(url);
  return data.data;
};

// export const getVendorsBySchoolDashboard = async ({ signal, schoolID }) => {
//   const { data } = await axios.get(`master/school/vendorlist?schoolID=${schoolID}`, {
//     signal,
//   });
//   return data.data;
// };
export const getVendorsBySchool = async ({ signal, schoolID }) => {
  const url =
    schoolID && schoolID.length
      ? `master/school/vendorlist?schoolID=${schoolID.join(",")}`
      : "master/school/vendorlist";

  const { data } = await axios.get(url, { signal });
  return data.data;
};
export const masterStudentAdd = async ({ signal, req, isEditMode }) => {
  if (isEditMode) {
    const { data } = await axios.post(`master/school/student/update`, req, { signal });
    return data?.data;
  }
  const { data } = await axios.post(`master/school/student/add`, req, { signal });
  return data.data;
};
export const masterGetDataByid = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/getData",
    {
      tableName: queryKey[1],
      page: +queryKey[2] + 1,
      limit: queryKey[3],
      where: [{ field: queryKey[4], operator: "=", value: queryKey[5] }],
    
    },
    { signal }
  );
  return data?.data[0] || [];
};
export const masterGetDataByidpackages = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/getData",
    {
      tableName: queryKey[1],
      page: +queryKey[2] + 1,
      limit: queryKey[3],
      where: [{ field: queryKey[4], operator: "=", value: queryKey[5] }],
    
    },
    { signal }
  );
  return data?.data[0] || [];
};
export const updateOrderStatus = async (orderIDs) => {
  try {
    const payload = { orderIDs };

    const { data } = await axios.patch("orders/school/schoolorderupdate", payload );

    return data;
  } catch (error) {
    throw error;
  }
};
export const ordersUpdate = async ({ signal, req }) => {
  const { data } = await axios.patch("orders/school/schoolorderupdate", req, { signal });
  return data.data;
};

// export const getvendor = async ({ signal, schoolID, allSchools = [] }) => {
//   try {
//     let params = {};

//     if (schoolID) {
//       // Agar specific school select hua hai
//       params.schoolID = schoolID;
//     } else if (allSchools.length > 0) {
//       // Agar sabhi school ka vendor chahiye
//       params.schoolID = allSchools.map((s) => s.branchID).join(",");
//     }

//     const { data } = await axios.get("/master/school/vendorlist", {
//       params,
//       signal,
//     });

//     return data || [];
//   } catch (err) {
//     console.error("Error fetching vendors:", err);
//     return [];
//   }
// };

export const invoiceGet = async ({ orderID, vendorId, signal }) => {
  const { data } = await axios(
    `/invoice/school/get/${orderID}?vendorId=${vendorId}`,
    { signal }
  );
  return data?.data[0] || {};
};

export const packageAdminList = async ({ queryKey, signal }) => {
  const { data } = await axios("package/admin/list/" + queryKey[1], {
    signal,
  });
  return data.data;
};

export const packageAdminConstituents = async (id) => {
  const { data } = await axios("package/admin/constituents/" + id);
  return data.data;
};
export const cartAdminAdd = async ({ signal, req }) => {
  const { data } = await axios.post("cart/school/add", req, { signal });
  return data;
};
export const getSchoolfilter = async (schoolID) => {
  try {
    const { data } = await axios.get(`/orders/school/groupschoollist/${schoolID}`);
    return Array.isArray(data?.data) ? data.data : [];
  } catch (error) {
    return [];
  }
};
export const schoolList = async ({ signal }) => {
  const { data } = await axios("school/school/List", { signal });
  return data;
};
export const fetchInventoryData = async (schoolID, standardID) => {
  let url = `report/school/packageinventorytarget?schoolID=${schoolID}`;
  if (standardID) {
    url += `&standardID=${standardID}`;
  }
  const response = await axios.get(url);
  return response.data.data[0] || [];
};
export const reportStudentWiseProduct = async (req) => {
  const { schoolID, packageID, productID, initialDate, endDate } = req;

  const params = new URLSearchParams();

  if (schoolID) params.append("schoolID", schoolID);  
  if (packageID) params.append("packageID", packageID);
  if (productID) params.append("productID", productID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);
  
  const url = `report/school/pendingProduct${params.toString() ? `?${params.toString()}` : ""}`;
  
  const response = await axios.get(url);
  return response.data.data;
  };
  export const reportSchoolWiseProduct = async (req) => {
    const { schoolID, packageID, productID, initialDate, endDate } = req;
  
    const params = new URLSearchParams();
  
    if (schoolID) params.append("schoolID", schoolID);
    if (packageID) params.append("packageID", packageID);
    if (productID) params.append("productID", productID);
    if (initialDate) params.append("initialDate", initialDate);
    if (endDate) params.append("endDate", endDate);
  
    const url = `/orders/school/schoolpendingprod${params.toString() ? `?${params.toString()}` : ""}`;
  
    const response = await axios.get(url);
    return response.data.data;
  };
  
export const reportNewAndPendingOrder = async req => {
  const { data } = await axios(
    `report/school/newAndPendingOrder/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const reportOrderProductReport = async (req) => {
  const { schoolID, initialDate, endDate } = req;

  const params = new URLSearchParams();
  if (schoolID) params.append("schoolID", schoolID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);

  const url = `report/school/orderProductReport?${params.toString()}`;
  const { data } = await axios(url);
  return data.data;
};
export const reportNewOrderReport = async req => {
  const { data } = await axios(
    `report/school/newOrderReport/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const reportPendingProduct = async req => {
  const { data } = await axios(
    `report/school/pendingProduct/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};



